import { CheckoutAuthenticatedComponent } from './checkout_authenticated.component';
import { CheckoutGuestComponent } from './checkout_guest.component';
import { CheckoutStepComponent } from './checkoutStep.component';

import { CheckoutStepsModule } from './checkoutSteps/checkoutSteps.module';
import { SummaryModule } from './summary/summary.module';

import { CheckoutService } from './checkout.service';
import { ErrorMessageService } from './error_message.service';

export const CheckoutModule = angular.module('oo.checkout', [
    CheckoutStepsModule,
    SummaryModule
])
    .component('checkoutAuthenticated', CheckoutAuthenticatedComponent)
    .component('checkoutStep', CheckoutStepComponent)
    .component('checkoutGuest', CheckoutGuestComponent)
    .service('checkoutService', CheckoutService)
    .service('errorMessageService', ErrorMessageService)
    .name;
